<template>
  <v-app-bar v-if="enableUp || enableNav"
             bottom
             fixed
             style="z-index: 6"
             color="yellow"
             height="0"
             :class="classesContainer"
  >
    <v-container class="d-flex flex-row- mb-0 height-0">
      <NavigationFab v-if="enableNav" class="d-block ml-n6" position="show" />
      <v-spacer class="height-0" />
      <v-fab-transition class="d-block">
        <Fab v-if="enableUp && active"
             class="d-block mr-n6 "
             icon="mdi-arrow-up-thick"
             @click="scrollUp"
        />
      </v-fab-transition>
    </v-container>
  </v-app-bar>
</template>

<script>
import Fab from '@/components/Fab';
import NavigationFab from '@/components/NavigationFab';

export default {
  name: 'ScrollUp',
  components: { NavigationFab, Fab },
  data: () => ({
    active: false
  }),
  computed: {
    enableNav() {
      const pos = this.$store.state.theme.navigationButton;
      return (pos === 'bottom-left' && this.readonly) || pos === 'bottom-left-fab';
    },
    enableUp() {
      return this.$store.state.theme.fabUp;
    },
    readonly() {
      return this.$store.state.data.settings.readonly;
    },
    classesContainer() {
      return {
        'mb-16': !this.readonly,
        'mb-10': this.readonly,
      };
    }
  },
  mounted() {
    if (this.enableUp) {
      window.addEventListener('scroll', this.check);
      this.check();
    }
  },
  methods: {
    check() {
      this.active = window.pageYOffset > 0;
    },
    scrollUp() {
      this.$vuetify.goTo(0, {
        duration: 500,
      });
    },
    nav() {
      const { navigation } = this.$store.state.ui;
      this.$store.commit('ui/navigation', !navigation);
    }
  }
};
</script>
